module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header",
    attrs: {
      "id": "dash-header"
    }
  }, [_c('nav', {
    staticClass: "clearfix section-header",
    attrs: {
      "id": "section-header"
    }
  }, [_c('ul', {
    staticClass: "clearfix font-size-body topnav",
    class: {
      'responsive': _vm.mobileMenuDisp
    }
  }, [_c('li', {
    staticClass: "layout-left font-size-header -logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "VVPHOTOGRAPHER",
      "src": require("../../../static/img/Logo2017.svg"),
      "width": "100",
      "height": "100"
    }
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix nav-column layout-right -personal1",
    class: {
      'active-page': _vm.$route.name === 'personalI'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'personalI'
      }
    }
  }, [_c('span', [_vm._v("PERSONAL I")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix nav-column layout-right -personal2",
    class: {
      'active-page': _vm.$route.name === 'personalII'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'personalII'
      }
    }
  }, [_c('span', [_vm._v("PERSONAL II")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix nav-column layout-right -personal3",
    class: {
      'active-page': _vm.$route.name === 'personalIII'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'personalIII'
      }
    }
  }, [_c('span', [_vm._v("PERSONAL III")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix nav-column layout-right",
    class: {
      'active-page': _vm.$route.name === 'workI'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'workI'
      }
    }
  }, [_c('span', [_vm._v("WORK I")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix nav-column layout-right",
    class: {
      'active-page': _vm.$route.name === 'workII'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'workII'
      }
    }
  }, [_c('span', [_vm._v("WORK II")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix nav-column layout-right",
    class: {
      'active-page': _vm.$route.name === 'workIII'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'workIII'
      }
    }
  }, [_c('span', [_vm._v("WORK III")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix nav-column layout-right",
    class: {
      'active-page': _vm.$route.name === 'bio'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bio'
      }
    }
  }, [_c('span', [_vm._v("Bio")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix nav-column layout-right",
    class: {
      'active-page': _vm.$route.name === 'contact'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_c('span', [_vm._v("Contact")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "clearfix icon"
  }, [_c('a', {
    staticStyle: {
      "font-size": "30px"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMobileMenuDisp()
      }
    }
  }, [_vm._v("☰")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e78dc6be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dash/components/dashHeader.vue
// module id = 596
// module chunks = 2